import React from "react";
// @jsx jsx
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { jsx } from "theme-ui";
import PointText from "../PointText";

interface Props {
  text: string;
  styles?: {};
}

export const SectionHeader: React.SFC<Props> = (props) => {
  return (
    <div
      sx={{
        marginY: [4, "unset"],
        width: "fit-content",
        height: "fit-content",
        borderBottom: "1px solid",
        borderBottomColor: "secondary",
        ...(props.styles || {}),
      }}
    >
      <PointText
        text={props.text}
        styles={{
          color: "background",
          mb: [0],
        }}
      />
    </div>
  );
};

export default SectionHeader;
